import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import { WidgetContainer, WidgetView } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import { Profile } from "model";
import React from 'react';
import "./styles.css";

/**
 * @function ChangeLoginWidget
 * @return {React.Component}
 * @exported true
 * @description A brandable widget component used in abi22 and mabi23 branding options.
 * Example branding option: "Account Details - Right Column Widget 1 (Default = None)"
 * (action script name: accountdetails_right_widget_1_abi22)
 */

export default function ChangeLoginWidget(props) {
  const profileID = props.profileID ?? Profile.getDefaultBrandedProfile().id;
  const profiles = props.profiles ?? Profile.initAll();
  const selectIsActive = props.selectIsActive ?? false;
  
  const items = profiles.reduce((acc, profile) => {
    acc.push(
      <CustomSelectItem key={ profile.id } value={ profile.id } dataPoint={ `Change_Login_Widget_Profile_Select_Item_${ profile.id }` }>{ profile.name }</CustomSelectItem>
    );
    return acc;
  }, []);

  return(
    <WidgetContainer className="change-login-widget">
        <WidgetView text="Change Login">
          <DisabledPrompt>
            <Link>Click here to Manage Login IDs</Link>
          </DisabledPrompt>
          <CustomSelect active={ selectIsActive } value={ profileID } dataPoint="Change_Login_Widget_Profile_Select">{ items }</CustomSelect>
          <DisabledPrompt>
            <PrimaryButton text="Change Login" />
          </DisabledPrompt>
        </WidgetView>
    </WidgetContainer>
  );
}